import { createStyles } from "@mantine/emotion";

export const useStylesCollectionWindow = createStyles((theme) => {
  return {
    collectionWindow: {
      ".text": {
        fontSize: theme.spacing.collectionWindow.fontSize.medium,
        lineHeight: theme.spacing.collectionWindow.lineHeight.text,
        paddingBottom: theme.spacing.xs,
      },
      ".success": {
        fontSize: theme.spacing.collectionWindow.fontSize.small,
        lineHeight: theme.spacing.collectionWindow.lineHeight.small,
        color: theme.customColors.green,
        fontFamily: theme.headings.fontFamily.light,
      },
      ".loading-wrap": {
        height: "6rem",
      },
      ".loading": {
        display: "block",
        width: "5rem",
        height: "5rem",
        border: "0.75rem solid " + theme.customColors.animationLoader,
        borderTop: "0.75rem solid " + theme.customColors.black,
        borderRadius: "50%",
        position: "absolute",
      },
      ".loading-title": {
        fontSize: theme.spacing.collectionWindow.fontSize.title,
        marginBottom: theme.spacing.collectionWindow.margin.bottom.large,
      },
      ".loading-confirmation-text": {
        fontSize: theme.spacing.collectionWindow.fontSize.text,
        fontFamily: theme.headings.fontFamily.light,
        marginBottom: theme.spacing.collectionWindow.margin.bottom.medium,
        textAlign: "center",
        marginTop: theme.spacing.collectionWindow.margin.bottom.large,
      },
      ".confirmation-title": {
        fontSize: theme.spacing.collectionWindow.fontSize.title,
        fontWeight: "bold",
        marginBottom: theme.spacing.collectionWindow.margin.bottom.large,
      },
      ".key": {
        fontSize: theme.spacing.collectionWindow.fontSize.text,
        fontFamily: theme.headings.fontFamily.light,
        fontWeight: "bold",
        marginBottom: theme.spacing.collectionWindow.margin.bottom.medium,
      },
      ".value": {
        fontSize: theme.spacing.collectionWindow.fontSize.text,
        fontFamily: theme.headings.fontFamily.light,
        marginBottom: theme.spacing.collectionWindow.margin.bottom.medium,
      },
      ".create-text": {
        fontSize: theme.spacing.collectionWindow.fontSize.title,
        marginTop: theme.spacing.xl,
        marginBottom: theme.spacing.collectionWindow.margin.bottom.large,
        fontWeight: "bold",
      },
    },
  };
});
